<template>
  <div class="q-layout layout">
    <div class="login">
      <h1 class="heading">Вход в кабинет</h1>
      <div class="form">
        <form autocomplete="off" novalidate @submit.prevent="login" method="post">
          <q-field>
            <q-input color="white" dark float-label="Электронная почта" type="email" v-model="form.username" :error="$v.form.username.$error" />
          </q-field>
          <q-field>
            <q-input color="white" dark float-label="Пароль" type="password" v-model="form.password" :error="$v.form.password.$error" />
          </q-field>
          <q-field class="q-mt-lg">
            <q-btn class="full-width" color="white" text-color="black" type="submit" :disable="disabled" :loading="form.loading">Войти</q-btn>
          </q-field>
        </form>
      </div>
      <div class="links" style="display: none;">
        <a href="#">Забыли пароль</a>
      </div>
    </div>
    <div class="footer">
      <div class="logo"></div>
    </div>
  </div>
</template>

<script>
  import {
    QField,
    QInput,
    QBtn,
    Notify
  } from 'quasar';

  import {
    required,
    email
  } from 'vuelidate/lib/validators';

  export default {
    components: {
      QField,
      QInput,
      QBtn,
      Notify
    },
    data() {
      return {
        form: {
          username: null,
          password: null,
          loading: false
        },
        disabled: true
      }
    },
    validations: {
      form: {
        username: {required, email},
        password: {required},
      }
    },
    created () {
      //console.log(this.$q.notify);
    },
    watch: {
      'form.username' () {
        this.disabled = !this.form.username || !this.form.password;
      },
      'form.password' () {
        this.disabled = !this.form.username || !this.form.password;
      }
    },
    methods: {
      login () {
        const self = this;

        this.form.loading = true;
        this.$v.form.$touch();

        if (this.$v.form.$error) {
          this.$q.notify('Please review fields again.');
          this.form.loading = false;
          return;
        }
        this.$http.post('/get-credentials', {
            email: self.form.username
        }).then((response) => {
          let credentials = response.data;

          if (credentials.hasOwnProperty('access_denied')) {
            this.$q.notify('Доступ запрещён');
            this.form.loading = false;
            return;
          }

          this.$auth.login({
            data: {
              "grant_type": "password",
              "client_id": credentials.OAUTH_CLIENT_ID,
              "client_secret": credentials.OAUTH_CLIENT_SECRET,
              "username": self.form.username,
              "password": self.form.password,
              "scope": "*"
            },
            success: function (response) {
              self.$auth.token(null, response.data.access_token);
              self.$auth.token('refresh_token', response.data.refresh_token);

              this.form.loading = false;
            },
            error: function (res) {
              console.log(res.response);
              this.$q.notify(res.response.data.message);
              this.form.loading = false;
            },
          })
        }).catch(error => {
          let response = error.response.data;

          if (response.hasOwnProperty('access_denied')) {
            this.$q.notify('Доступ запрещён');
            this.form.loading = false;
            return;
          }

          this.$q.notify(response.message);
          this.form.loading = false;
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .layout {
    display: flex;
    align-items: center;
    justify-content: center;
    background: #63AEF5;
  }

  .login {
    width: 300px;
    //color: #fff;

    .q-if:before,
    /deep/ .q-if-label {
      color: #B1D6FA;
    }

    .q-btn {
      background: #fff;
    }
  }

  .heading {
    font-size: 32px;
    font-weight: 300;
    text-align: center;
    color: #fff;
  }

  .links {
    display: flex;
    justify-content: space-between;
  }
</style>


// WEBPACK FOOTER //
// resources/assets/js/views/LoginView.vue